import MailScopeRequest from 'src/adminPanel/entities/it/mail/MailTemplateScopeRequest';
import Mail from '../adminPanel/entities/it/mail/Mail';
import { CallApiResult, callInternalApi } from '../api';

export const getMailTemplateAdmin = (): Promise<CallApiResult> => {
    return callInternalApi('/mail/v3/mailKeys');
};

export const updateMailTemplateAdmin = (requestMail: Mail): Promise<CallApiResult> => {
    return callInternalApi('/mail/v3/mailKeys/' + requestMail.id, {
        method: 'PUT',
        data: requestMail,
    });
};

export const addNewMailScopeToMailKey = (mailScopeRequest: MailScopeRequest): Promise<CallApiResult> => {
    return callInternalApi('/mail/v3/mailScope/', { method: 'POST', data: mailScopeRequest });
};

export const deleteMailScopeFromMailKey = (mailScopeId: string): Promise<CallApiResult> => {
    return callInternalApi('/mail/v3/mailScope/' + mailScopeId, { method: 'DELETE' });
};

export const getPreviewOfMailTemplate = (
    previewKey: string,
    previewRequest: Record<string, string>,
    region: string,
    language: string
) => {
    return callInternalApi('/mail/v3/preview/' + previewKey, {
        method: 'POST',
        data: previewRequest,
        headers: { region, language },
    });
};

export const sendMailPreview = (
    mailKey: string,
    receivers: string[],
    scopes: Record<string, string>,
    region: string,
    language: string
) => {
    return callInternalApi('/mail/v3/send/' + mailKey, {
        method: 'POST',
        data: { receivers, scopes },
        headers: { region, language },
    });
};
